// extracted by mini-css-extract-plugin
export var divider = "_1i-0";
export var dividerText = "_1i-2";
export var dividerVertical = "_1i-1";